import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './languages/en'
import sv from './languages/sv'

export const translations = { en, sv } as const

const resources = Object.entries(translations).reduce(
  (acc, [key, value]) => ({ ...acc, [key]: { translation: value } }),
  {},
)

export type AvailableLocale = keyof typeof translations

export const availableLocales = Object.keys(translations) as AvailableLocale[]

export const fallbackLng = 'en'

/**
 * @description Used for looking for missing translations and breaking UI in development
 */
export const enablePizzaDebugLanguage = (length = 20) => {
  if (import.meta.env.VITE_DEV !== 'true') return
  // @ts-expect-error
  i18n.t = () => Array.from({ length }, () => '🍕').join('')
}

export const initI18n = () => {
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      fallbackLng,
      interpolation: {
        escapeValue: false,
      },
      resources,
      supportedLngs: availableLocales,
    })
}

export default i18n
